import React from 'react';

const Maintenance = () => (
  <main className="maintenance-page" data-testid="maintenance-page">
    <img className="maintenance-image" src="/images/campaign.webp" alt="Jean WEARHOUSE 60 porté" />
    <div className="maintenance-shade" />
    <div className="maintenance-content" data-testid="maintenance-status">
      <p className="maintenance-eyebrow">WEARHOUSE 60</p>
      <h1>La boutique<br />revient bientôt.</h1>
      <p>Nous préparons la suite. Merci de revenir dans quelques instants.</p>
    </div>
  </main>
);

export default Maintenance;